import { render, staticRenderFns } from "./AdminManageToolTags.vue?vue&type=template&id=36c3967a&scoped=true"
import script from "./AdminManageToolTags.vue?vue&type=script&lang=ts"
export * from "./AdminManageToolTags.vue?vue&type=script&lang=ts"
import style0 from "./AdminManageToolTags.vue?vue&type=style&index=0&id=36c3967a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c3967a",
  null
  
)

export default component.exports